var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"sikka-buya-button button",attrs:{"to":_vm.to,"target":"_blank"}},[_c('img',{attrs:{"src":"/image/logos/sikka-buya-icon-only.svg"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }